import supabase from '../supabase/supabase';
import { storageService } from './storageService';
import { fetchAllPages } from './paginatedFetch';

const imageOf = (item) => item?.imageUrl || item?.image_url || '';

export const listingService = {
  async getAll(options = {}) {
    return fetchAllPages(
      () => supabase.from('listings').select('*').order('created_at', { ascending: false }),
      { ...options, label: 'Angebote' },
    );
  },

  async getById(id) {
    const { data, error } = await supabase.from('listings').select('*').eq('id', id).single();
    if (error) throw error;
    return data;
  },

  async create(data) {
    const imageUrl = await storageService.uploadDataUrl(data.imageUrl || data.image_url, {
      userId: data.providerId || data.provider_id,
      folder: 'listings',
    });

    const { data: newListing, error } = await supabase.from('listings').insert([{
      ...data,
      imageUrl,
      quantity: parseInt(data.quantity, 10) || 1,
      status: 'available',
    }]).select().single();
    if (error) {
      if (imageUrl && imageUrl !== data.imageUrl && imageUrl !== data.image_url) {
        storageService.removePublicUrl(imageUrl).catch(() => undefined);
      }
      throw error;
    }
    return newListing;
  },

  async update(id, dataToUpdate) {
    const hasNewInlineImage = storageService.isInlineImage(dataToUpdate.imageUrl || dataToUpdate.image_url);
    const previous = hasNewInlineImage ? await this.getById(id) : null;
    const imageUrl = hasNewInlineImage
      ? await storageService.uploadDataUrl(dataToUpdate.imageUrl || dataToUpdate.image_url, {
        userId: dataToUpdate.providerId || dataToUpdate.provider_id || previous?.providerId || previous?.provider_id,
        folder: 'listings',
      })
      : (dataToUpdate.imageUrl || dataToUpdate.image_url);

    const payload = {
      ...dataToUpdate,
      ...(imageUrl !== undefined ? { imageUrl } : {}),
      updated_at: new Date().toISOString(),
    };

    const { data, error } = await supabase.from('listings').update(payload).eq('id', id).select().single();
    if (error) {
      if (hasNewInlineImage && imageUrl) storageService.removePublicUrl(imageUrl).catch(() => undefined);
      throw error;
    }

    const previousImage = imageOf(previous);
    if (hasNewInlineImage && previousImage && previousImage !== imageUrl) {
      storageService.removePublicUrl(previousImage).catch((storageError) => console.warn('Altes Angebotsbild konnte nicht gelöscht werden:', storageError));
    }

    return data;
  },

  async updateQuantity(id, newQuantity) {
    return this.update(id, { quantity: newQuantity, status: newQuantity <= 0 ? 'gone' : 'available' });
  },

  async remove(id) {
    let previous = null;
    try {
      previous = await this.getById(id);
    } catch {
      previous = null;
    }

    const { error } = await supabase.from('listings').delete().eq('id', id);
    if (error) throw error;

    const previousImage = imageOf(previous);
    if (previousImage) {
      storageService.removePublicUrl(previousImage).catch((storageError) => console.warn('Angebotsbild konnte nicht gelöscht werden:', storageError));
    }
  },
};
